import {UseFormWatch, UseFormSetValue, Control} from 'react-hook-form';
import AppMUIAutocomplete from '../../../../../../../components/common/AppMUIAutoComplete';
import {FormDataType, RATING_ICONS} from '../../../types';

type Props = {
  index: number;
  watch: UseFormWatch<FormDataType>;
  control: Control<FormDataType>;
  setValue: UseFormSetValue<FormDataType>;
};

function RatingField({index, watch, setValue}: Props) {
  const limitOptions = Array.from({length: 10}, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  }));

  const maxRating =
    (watch(`questions.${index}.maxRating` as any) as number) ?? 5;
  const iconValue =
    (watch(`questions.${index}.icon` as any) as string) ?? 'star';

  const selectedRatingIcon =
    RATING_ICONS.find(r => r.value === iconValue) || RATING_ICONS[0];

  return (
    <div className="flex gap-16">
      {/* Controls row */}
      <div className="flex items-center gap-3">
        {/* Limit dropdown */}
        <div className="w-[101px]">
          <AppMUIAutocomplete
            size="small"
            options={limitOptions}
            value={
              limitOptions.find(opt => opt.value === maxRating) ||
              limitOptions[4]
            }
            getOptionLabel={option => option.label}
            onChange={(_, newValue) => {
              if (newValue) {
                setValue(
                  `questions.${index}.maxRating` as any,
                  newValue.value,
                  {
                    shouldDirty: true,
                  },
                );
              }
            }}
            disableClearable
          />
        </div>

        {/* Icon type dropdown */}
        <div className="w-[101px]">
          <AppMUIAutocomplete
            size="small"
            options={RATING_ICONS}
            value={selectedRatingIcon}
            getOptionLabel={() => ''}
            onChange={(_, newValue) => {
              if (newValue) {
                setValue(`questions.${index}.icon` as any, newValue.value, {
                  shouldDirty: true,
                });
              }
            }}
            disableClearable
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                <img
                  src={option.dropdownIcon}
                  alt={option.value}
                  className="w-[20px] h-[20px] object-contain"
                />
              </li>
            )}
            startAdornment={
              <img
                src={selectedRatingIcon.dropdownIcon}
                alt={selectedRatingIcon.value}
                className="w-[20px] h-[20px] object-contain"
              />
            }
          />
        </div>
      </div>

      {/* Empty icons preview row */}
      <div className="flex flex-row-reverse items-center gap-4">
        {Array.from({length: maxRating}, (_, i) => (
          <div className="flex flex-col items-center gap-2" key={i}>
            <span className="text-textColor">{i + 1}</span>
            <img
              src={selectedRatingIcon.emptyIcon}
              alt={`${selectedRatingIcon.value} ${i + 1}`}
              className="w-[24px] h-[24px] object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default RatingField;
